/**
 * Right Panel Module.
 *
 * The Gallery waterfall PICKER was removed (ADR-005 2.8.0 pin #1): the single
 * source picker is the slot-click modal (pick-modal.js), so a second docked
 * picker was redundant. Tab visibility + switching is owned by router.js
 * (MODE_TABS, fully mode-scoped). Inspiration cards render via
 * inspiration-workspace.js into #inspirationCardsCol; the seed wall renders
 * via inspiration-wall.js (H-2026-09-12-128 2a). This module now only
 * populates the Community tab with the resident style cards
 * (H-2026-09-12-128 2b).
 */

import { renderCommunityStyles } from './community-styles.js'

export function initRightPanel() {
  renderCommunityStyles()
}
